import { useMutation } from "@apollo/client";

import { GqlSettingsEcologicalFunctionTypeCreateInput } from "~/__generated__";

import { SettingsFunctionTypeCreateRoute_CreateDocument } from "../mutations.generated";

export default function useSettingsFunctionTypeCreateRoute_Create() {
    const [mutate, { loading, error }] = useMutation(SettingsFunctionTypeCreateRoute_CreateDocument, {});

    const createFunctionType = async (input: GqlSettingsEcologicalFunctionTypeCreateInput) => {
        const result = await mutate({
            variables: {
                input,
            },
        });
        return result.data?.settingsEcologicalFunctionTypeCreate;
    };

    return {
        createFunctionType,
        loading,
        error,
    };
}
